import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'fixCurrency'
})
export class FixCurrencyPipe implements PipeTransform {

  transform(locale: string): string {
    return locale === 'sk' ? 'cs' : locale;
  }

}
